import { ReceiptsTable, StatusMessage } from '@krp/ui-kit'

import { OneCQueryState } from '../../../shared/ui/OneCQueryState'
import type { CashCorrectionsVm } from '../model/types'

/**
 * Таб «Чеки коррекции» (RP-ST15): чеки коррекции базы 1С за период вкладки у выбранного места — та же общая таблица чеков, что у
 * чеков ККМ, плюс тип расчёта, дата исправляемого расчёта, тип коррекции, предписание и «пробит ли». Своего окна у чека коррекции нет —
 * строки только для чтения. Незнакомое значение 1С стоит дословно, как его подписала служба. В итоги и графики чеки коррекции не входят.
 */
export function CashCorrectionsTable({ vm, onRetry }: { vm: CashCorrectionsVm; onRetry: () => void }) {
  if (vm.periodError !== null) return <StatusMessage kind="empty" title={vm.periodError} />
  return (
    <>
      {vm.truncatedNote !== null && <StatusMessage kind="empty" title="Показаны не все чеки коррекции" text={vm.truncatedNote} />}
      <OneCQueryState query={vm.query} emptyText="За период чеков коррекции нет" onRetry={onRetry} />
      {vm.filteredOut && <StatusMessage kind="empty" title="У выбранного места чеков коррекции нет" text="Чеки коррекции за период есть у других касс базы: выберите место выше по дереву." />}
      {vm.rows.length > 0 && (
        <ReceiptsTable label="Чеки коррекции" rows={vm.rows} columns={[
          { id: 'settlement', label: 'Тип расчёта', cell: (row) => row.settlement, title: (row) => row.settlement },
          { id: 'corrected', label: 'Исправляемый расчёт', cell: (row) => row.corrected, title: (row) => row.corrected },
          { id: 'correction-kind', label: 'Тип коррекции', cell: (row) => row.correctionKind, title: (row) => row.correctionKind },
          { id: 'order', label: 'Предписание', cell: (row) => row.order, title: (row) => row.order },
          { id: 'printed', label: 'Пробит', cell: (row) => row.printed, title: (row) => row.printed },
          { id: 'other', label: 'Прочая оплата', cell: (row) => row.other, title: (row) => row.other },
        ]} />
      )}
    </>
  )
}
